import moment from 'moment';

import sumDollarAmounts from '../../../../../../helpers/sumDollarAmounts';
import { formatCurrency } from '../../../../../../helpers/currencyMask';

const memo = new Map();

const calculateScheduledDistribution = ({
  row,
  bills,
  shouldReturnRawValue = false,
  billType,
}) => {
  if (memo.has(row.id)) {
    return memo.get(row.id);
  }

  const { date } = row;

  const scheduledBills = bills
    ?.filter((bill) => {
      if (billType && billType !== bill.type) {
        return false;
      }

      return moment(bill.due_date).isSame(date, 'month');
    })
    // If bill.status !== 'paid', then _amount.total instead of _paid_from_impound.amount should be used for the distribution calculation
    .map((bill) => {
      if (bill.status !== 'paid') {
        return {
          ...bill,
          _paid_from_impound: { amount: bill._amount?.total || 0 },
          _paid_to_impound: { amount: 0 },
        };
      }
      return bill;
    });

  // Use previous year bills if no exact date bills are found
  let scheduledBillsTotal = 0;

  if (row.status !== 'paid') {
    scheduledBillsTotal = sumDollarAmounts(scheduledBills, '_amount.total');
  } else {
    const paidFrom = sumDollarAmounts(
      scheduledBills,
      '_paid_from_impound.amount'
    );
    const paidTo = sumDollarAmounts(scheduledBills, '_paid_to_impound.amount');

    scheduledBillsTotal = sumDollarAmounts(
      [{ amount: paidFrom }, { amount: paidTo }],
      'amount'
    );
  }

  // eslint-disable-next-line no-restricted-globals
  if (isNaN(scheduledBillsTotal)) {
    scheduledBillsTotal = 0;
  }

  if (scheduledBillsTotal === 0) {
    return { sum: shouldReturnRawValue ? 0 : '-' };
  }

  if (shouldReturnRawValue) {
    return { sum: scheduledBillsTotal };
  }

  const isNegative = scheduledBillsTotal < 0;
  const sum = isNegative
    ? `$(${formatCurrency(scheduledBillsTotal)})`
    : `$${formatCurrency(scheduledBillsTotal)}`;

  const result = {
    sum,
    amounts: scheduledBills.map((bill) => {
      if (row.status !== 'paid') {
        return bill?._amount?.total || 0;
      }
      return sumDollarAmounts(
        [
          { amount: bill?._paid_from_impound?.amount || 0 },
          { amount: bill?._paid_to_impound?.amount || 0 },
        ],
        'amount'
      );
    }),
  };

  memo.set(row.id, result);

  return result;
};

export default calculateScheduledDistribution;

export const clearScheduledDistributionMemo = () => memo.clear();
